import React from 'react';
import './Filters.css';
import '../scss/custom.scss';
import ReactExport from "react-export-excel";

class Filters extends React.Component {
    state = {
        selectedFilter:"YTD",
        buttonOptions:["MTH","YTD","QTR"],
        showQuarter:false,
        year:2020,
        month:this.props.defaultMonth,
        //month:1,
        quarter:1,
        // buyingGroupId: 1,
        // isCompliant: "Y",
        
    }

    handleUserSelectedFilter(option){
        if(option==="qtr" || option==="QTR"){
            this.setState({showQuarter:true});
        }else{
            this.setState({showQuarter:false});
        }
        this.setState({selectedFilter:option},()=>{
            this.props.setFilter({period:this.state.selectedFilter,year:this.state.year,quarter:this.state.quarter,month:this.state.month});
        });
        
    }


    componentDidMount(){
        console.log('filters ',this.props.showMonth=="false");
        console.log(this.state.showQuarter);
        if(this.props.showMonth=="false" && this.state.showQuarter===false){
            this.setState({showQuarter:false,buttonOptions:["YTD","QTR"],selectedFilter:"YTD"});
        }
    }

    handleChangeOfDropdown(event){
        let obj = {};
        obj[event.name] = event.value;
        this.setState(obj,()=>{
            this.props.setFilter({period:this.state.selectedFilter,year:this.state.year,quarter:this.state.quarter,month:this.state.month});
        });
    }

   renderButtonGroup(){
    
       return this.state.buttonOptions.map((option,index)=>{
        return (
            <button style = {{height : '38px'}} key={index} type="button" value={option} 
            onClick={(e)=>{console.log(e.target.value);this.handleUserSelectedFilter(e.target.value)}} 
            class={`btn btn-light ${(this.state.selectedFilter===option)?"active":null}`}>{option}</button>
        )
       })
   }

    render() {
        const { showQuarter } = this.state;
        const { monthName } = this.props;
        return (
                <div className="row rowForFilters" >
                    <ul className="navbar-nav flexRowForFilters" >
                        <li className="nav-item">
                            <div className="btn-group">
                                {this.renderButtonGroup()}   
                             </div>
                        </li>
                        <li className="nav-item">
                        <select className="form-control" onChange={(e)=>{this.handleChangeOfDropdown({name:"year",value:e.target.value})}}>
                                <option value="2020" defaultValue = "2020" >2020</option>
                                <option value="2019">2019</option>
                                <option value="2018">2018</option>
                                <option value="2017">2017</option>
                            </select>
                        </li>
                        { showQuarter ? 
                        <li className="nav-item">
                            <select className="form-control" onChange={(e)=>{this.handleChangeOfDropdown({name:"quarter",value:e.target.value})}}>
                                <option value="1" defaultValue = "1">QTR1</option>
                                <option value="2">QTR2</option>
                                <option value="3">QTR3</option>
                                <option value="4">QTR4</option>
                            </select>
                   
                    </li>
                     :
                        <li className="nav-item">
                           
                                <select className="form-control" onChange={(e)=>{console.log(e.target.value);this.handleChangeOfDropdown({name:"month",value:e.target.value})}}>
                                <option value="1" selected={this.props.monthName == "Jan" ? true : false}>Jan</option>
                                <option value="2" selected={this.props.monthName == "Feb" ? true : false}>Feb</option>
                                <option value="3" selected={this.props.monthName == "Mar" ? true : false}>Mar</option>
                                <option value="4" selected={this.props.monthName == "Apr" ? true : false}>Apr</option>
                                <option value="5" selected={this.props.monthName == "May" ? true : false}>May</option>
                                <option value="6" selected={this.props.monthName == "Jun" ? true : false}>Jun</option>
                                <option value="7" selected={this.props.monthName == "Jul" ? true : false}>Jul</option>
                                <option value="8" selected={this.props.monthName == "Aug" ? true : false}>Aug</option>
                                <option value="9" selected={this.props.monthName == "Sep" ? true : false}>Sep</option>
                                <option value="10" selected={this.props.monthName == "Oct" ? true : false}>Oct</option>
                                <option value="11" selected={this.props.monthName == "Nov" ? true : false}>Nov</option>
                                <option value="12" selected={this.props.monthName == "Dec" ? true : false}>Dec</option>
                            </select>
                        </li>
                        }
                    </ul>

                </div>
        );
    }
}

export default Filters;
